import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center py-32"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InsightsNavbar = _resolveComponent("InsightsNavbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InsightsNavbar),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary-purple" }, null, -1)
        ]))]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
  ]))
}